import { render, staticRenderFns } from "./main-news.vue?vue&type=template&id=a3d93f5a&scoped=true&"
import script from "./main-news.vue?vue&type=script&lang=js&"
export * from "./main-news.vue?vue&type=script&lang=js&"
import style0 from "./main-news.vue?vue&type=style&index=0&id=a3d93f5a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3d93f5a",
  null
  
)

export default component.exports